import React, { type ReactNode } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Link } from '@mentimeter/ragnar-ui/link';
import { useTranslations } from 'next-intl';
import { useIsCurrentBrowserOutdated } from './hooks/useIsCurrentBrowserOutdated';

// Define UpdateLink outside the component
const UpdateLink = (chunks: ReactNode) => (
  <Link
    href="http://outdatedbrowser.com/"
    target="_blank"
    rel="noopener noreferrer"
  >
    {chunks}
  </Link>
);

export function SupportedBrowsersOnly({
  children,
  fallback,
}: { children: ReactNode; fallback?: ReactNode }) {
  const isOutdatedBrowser = useIsCurrentBrowserOutdated();
  // Use the error namespace
  const t = useTranslations('first_impression.error');

  if (isOutdatedBrowser) {
    return (
      fallback || (
        <Text m="auto" p={6} textAlign="center">
          {t.rich('outdated_browser_message', { UpdateLink })}
        </Text>
      )
    );
  }
  return children;
}
